var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Assets","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"icon/arrow"},[React.createElement("rect",{"id":"bounds","x":"0","y":"0","width":"24","height":"24","key":0}),React.createElement("polyline",{"id":"Path-2","stroke":"#333333","strokeLinecap":"round","strokeLinejoin":"round","points":"6 9 12 15 18 9","key":1})])));
}

AngleDown.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
